import compose from 'react-hooks-compose'

import { useLogoutButtonLogic } from './useLogic'
import { LogoutButtonPresenter } from './presenter'

export const LogoutButton = compose(props => ({
	useLogic: () => useLogoutButtonLogic(props),
}))(LogoutButtonPresenter)
